
//  http://localhost:3000/en/account/autologin?token=!oPWwl$u2HGU8J6IZfc5z7NFYSAK3k&email=kazadiabondance@gmail.com&redirect=https://dev.jeanmarcphilippe.com/en/account/loyalty

import { CustumerHelpers } from '@/helpers/CustumerHelpers';
import CustomerService from '@/services/CustomerService';
import { ShopSettings } from '@/services/ShopSettings';

export default {
  layout: 'MainLayout',
  name: 'AutoLoginPage',
  data() {
    return {
      customerService: new CustomerService({
        http: this.$http,
        auth: this.$auth,
        store: this.$store,
      }),
    };
  },
  created() {
    const { code } = this.$route.params;
    const shopSettings = new ShopSettings(this.$http, this.$store);
    shopSettings.shortLink({ code }).then((data) => {
      //{
      //     "Code": "43bzGYM",
      //     "TargetUrl": "https://dev.jeanmarcphilippe.com/fr/account/autologin?token=1r5Dp62Qwj$K4sfxHL97!XGT_@30Jo&email=ghislain.dorgeville@gmail.com&idCart=24492&redirect=/cart",
      //     "CreatedAt": "2025-10-23 11:14:48",
      //     "UpdatedAt": "",
      //     "ExpireAt": "2025-11-30 11:14:59",
      //     "Autologin": false
      // }
      const url = new URL(data.TargetUrl);
      const token = url.searchParams.get('token');
      const email = url.searchParams.get('email');
      const redirect = url.searchParams.get('redirect');
      const autologin = url.searchParams.get('autologin');

      if (autologin) {
        this.customerService
          .loginAuto({
            email,
            token,
          })
          .then((data) => {
            this.redirectTo(redirect);
          })
          .catch((err) => {
            this.$router.push({
              path: this.localePath({ name: 'index' }),
            });
          });
      } else {
        window.location.href = data.TargetUrl;
      }
    });
  },
  methods: {
    redirectTo(redirect) {
      let goTo = { name: 'account' };
      if (redirect) {
        goTo = redirect;
      }
      this.$router.replace({
        path: this.localePath(goTo),
      });
    },
  },
};
